import axios from 'axios'
import Zone from '@/dto/Zone/Zone'
import ZoneItem from '@/dto/Zone/ZoneItem'
import ZoneItemFactory from '@/services/factories/ZoneItemFactory'

const ZoneService = {
  getZonesByDeliveryId(deliveryId: number): Promise<Zone[]> {
    return axios
      .get(`/admin/deliveries/${deliveryId}/zones`)
      .then(response => response.data.zones)
  },

  createZone(deliveryId: number, zoneName: string) {
    return axios
      .post(`/admin/deliveries/${deliveryId}/zones`, { name: zoneName })
      .then(response => response.data.zone)
  },

  updateZone(zone: Zone) {
    return axios
      .put(`/admin/zones/${zone.id}`, {
        name: zone.name,
      })
      .then(response => response.data.zone)
  },

  deleteZone(zoneId: number) {
    return axios
      .delete(`/admin/zones/${zoneId}`)
      .then(response => response.data.zone)
  },

  saveZoneItems(zoneId: number, items: ZoneItem[]): Promise<ZoneItem[]> {
    return axios
      .put(`/admin/zones/${zoneId}/items`, {
        // Соблюдаем структуру айтемов, даже для новых строк
        items: items.map(item => ZoneItemFactory(item)),
      })
      .then(response => response.data.gridItems)
  },
}

export default ZoneService
